import { http } from 'core/utils/httpClient';
import type { ChartSettingsRequest } from './dtoModels/analytics/chartSettingsRequest';
import type { GeneralMetricsResponse } from './dtoModels/analytics/generalMetricsResponse';
import type { OrdersAnalyticResponse } from './dtoModels/analytics/orderAnalyticResponse';
import type { RevenueAnalyticResponse } from './dtoModels/analytics/revenueAnalyticResponse';
import type { GeneralMetrics } from 'models/analytics/generalMetrics';
import type { OrdersAnalytic } from 'models/analytics/orderAnalytic';
import type { RevenueAnalytic } from 'models/analytics/revenueAnalytic';

const mapOrdersAnalytic = (source: OrdersAnalyticResponse): OrdersAnalytic => ({
  ...source,
  date: new Date(source.date),
});

const mapOrdersAnalytics = (source: OrdersAnalyticResponse[]): OrdersAnalytic[] =>
  source.map((s) => mapOrdersAnalytic(s));

const mapRevenueAnalytic = (source: RevenueAnalyticResponse): RevenueAnalytic => ({
  ...source,
  date: new Date(source.date),
});

const mapRevenueAnalytics = (source: RevenueAnalyticResponse[]): RevenueAnalytic[] =>
  source.map((s) => mapRevenueAnalytic(s));

export const analyticsService = {
  async getAnalytics(): Promise<GeneralMetrics> {
    const { data } = await http.get<GeneralMetricsResponse>('analytics');

    return data;
  },

  async getOrdersAnalytic(settings: ChartSettingsRequest): Promise<OrdersAnalytic[]> {
    const { data } = await http.get<OrdersAnalyticResponse[]>('analytics/orders', {
      params: settings,
    });

    return mapOrdersAnalytics(data);
  },

  async getRevenueAnalytic(settings: ChartSettingsRequest): Promise<RevenueAnalytic[]> {
    const { data } = await http.get<RevenueAnalyticResponse[]>('analytics/revenue', {
      params: settings,
    });

    return mapRevenueAnalytics(data);
  },
};
